import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import {
  BiLoggerContextProvider,
  BiLink,
  BiEventType,
} from '@wix/da-shared-react/pkg/biLogger';
import { RelatedTopics as RelatedTopicsType } from '@wix/da-shared-react/pkg/types/topics';

import s from './RelatedTopics.scss';

// spec: limit number of topics
export const MAX_TOPICS = 5;

export interface Props {
  topics?: RelatedTopicsType;
  className?: string;
}

export const RelatedTopics: React.FC<Props> = ({ topics = [], className }) => {
  const { t } = useTranslation();
  const first5Topics = topics.slice(0, MAX_TOPICS);
  if (first5Topics.length <= 0) {
    return null;
  }

  return (
    <nav className={classnames(s['root'], className)}>
      <BiLoggerContextProvider value={{ sectionname: 'related_topics' }}>
        <h6 className={s['title']}>
          {t('topicPage.topicHeader.relatedTopics')}
        </h6>

        <ul className={s['list']}>
          {first5Topics.map(topic => (
            <li className={s['topic']} key={topic.name}>
              <BiLink
                href={topic.url}
                biData={{
                  evid: BiEventType.ITEM_CLICK,
                  typeid: topic.typeId,
                  itemid: topic.itemId,
                }}
              >
                {topic.name}
              </BiLink>
            </li>
          ))}
        </ul>
      </BiLoggerContextProvider>
    </nav>
  );
};
RelatedTopics.displayName = 'RelatedTopicsC105M';
export default RelatedTopics;
